import React from 'react';
import { Text, View, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { updatePatientFromCase, setEditingPatient, resetState } from '../patient/actions';

import { getEditingPatient } from '../patient/selector';

import { PHA } from '../../constants/permissions';
import { currentEmployerPermissions, editingCasePermissions } from '../../helpers/permissions';

import { getEditingCase } from '../cases/selector';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

import {
  OPComponent,
  Container,
  NavBar,
  I18n,
  Utils,
  Navigation,
  CheckButton,
  DateUtils,
  NextButton,
  FieldLabel,
} from '../components';

import SelectedAirman from './selected_airman';

const FLY_CHECK_COUNT = 7;
const CHECK_COUNT = 5;

class CustomCheckButton extends OPComponent {
  constructor(props) {
    super(props);
    this.state = {
      checked: props.checked,
    };
  }

  handlePress = (value, checked) => {
    this.setState({ checked });
    this.props.onCheck(checked);
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.checked !== prevProps.checked) {
      this.setState({ checked: this.props.checked });
    }
  }

  render() {
    return (
      <CheckButton
        noTopBorder={true}
        noBottomBorder={true}
        containerStyle={styles.checkButton}
        onPress={this.handlePress}
        checked={this.state.checked}
        disabled={!!this.props.disabled}
      />
    );
  }
}

class PHAChecklist extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      checkCount: 0,
    };
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Utils.trackScreen('Airforce', 'PHAChecklist');

    const editable = this.props.canEdit;
    Navigation.setButtons(
      {
        leftButtons: [NavBar.buttons.done],
      },
      this.props.componentId
    );
    Navigation.registerForButtonEvents(this);

    this.props.actions.setEditingPatient(this.props.editingCase.patientId);
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    if (!this.props.skipResetOnUnMount) {
      this.props.actions.resetState();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const errorMessage = this.props.errorMessage;
    if (errorMessage && errorMessage.message !== this.state.errorMessage) {
      this.setState({ errorMessage: errorMessage.message });
    }

    if (this._approved(prevProps) && !this._approved()) {
    }
  }

  approvePHA = () => {
    const props = this.props;
    const c = props.editingCase;
    const patient = props.editingPatient;

    const adminDate = new Date();

    const alreadyApproved = this._approved();

    let patientObj = {
      fullName: patient.fullName,
      email: patient.email,
      phone: patient.phone,
      extraData: {
        ...patient.extraData,
        pha: {
          ...(patient.extraData?.pha || {}),
          approvedDate: alreadyApproved ? null : adminDate.toISOString(),
          approvedBy: alreadyApproved ? null : this.props.userId,
        },
      },
    };
    this.props.actions.updatePatientFromCase({ caseId: c.caseId, patient: patientObj });
  };

  renderSelectedCase = () => {
    const c = this.props.editingCase;
    const patient = this.props.editingPatient;
    if (!c || !patient) return null;

    return (
      <SelectedAirman case={c} patient={patient}>
        <View style={{ alignItems: 'center', paddingRight: 10 }}>
          <Text style={[THEME.textMedium, { textAlign: 'center', marginBottom: 5 }]}>Status</Text>
          {this.renderStatusDot()}
        </View>
      </SelectedAirman>
    );
  };

  renderStatusDot = () => {
    const c = this.props.editingCase;
    const patient = this.props.editingPatient;
    if (!c || !patient) return null;

    const approved = this._approved();
    const phaDueDate = patient?.extraData?.pha?.dueDate;
    const nowDate = new Date();

    let bgcolor = COLOR.textLight;
    if (approved) {
      bgcolor = COLOR.success;
    } else if (!!patient?.extraData?.pha?.dueDate) {
      if (phaDueDate < nowDate) {
        bgcolor = COLOR.emphasis;
      } else {
        bgcolor = COLOR.warn;
      }
    }

    return <View style={[styles.statusDot, { backgroundColor: bgcolor }]} />;
  };

  handleCheck = (checked) => {
    let checkCount = this.state.checkCount;
    if (checked) checkCount++;
    else checkCount--;
    this.setState({ checkCount });
  };

  _approved(props) {
    // return true;
    props = props || this.props;
    const patient = props.editingPatient;
    const approvedDate = patient?.extraData?.pha?.approvedDate;
    return !!approvedDate;
  }

  _due() {
    return !!this.props?.editingPatient?.extraData?.pha?.dueDate;
  }

  makeCheckButton() {
    return (
      <CustomCheckButton onCheck={this.handleCheck} checked={this._approved()} disabled={false} />
    );
  }

  renderDueDate() {
    if (!this._due()) return null;

    const props = this.props;
    const patient = props.editingPatient;
    const dueDate = patient?.extraData?.pha?.dueDate;
    const dateStr = dueDate ? DateUtils.formatDateString(dueDate) : '';

    return (
      <View style={[THEME.inputsContainer]}>
        <FieldLabel label={'PHA Due By'} required={false} value={'PHA Due By'} />
        <Text style={styles.displayVal}>{dateStr}</Text>
      </View>
    );
  }

  renderFlyPHA() {
    if (!this._due()) return null;
    if (!this.props.fly) return null;

    return (
      <View>
        <View style={[THEME.headerAltContrast, { paddingRight: 10, flexDirection: 'row' }]}>
          <Text style={[styles.headerText, { flex: 1, textAlign: 'left' }]}>Step</Text>
          <Text style={[styles.headerText, styles.checkBoxContainer]}>SM</Text>
          <Text numberOfLines={2} style={[styles.headerText, styles.checkBoxContainer]}>
            Flight Medicine
          </Text>
          <Text style={[styles.headerText, styles.checkBoxContainer]}>Provider</Text>
        </View>
        <View style={[styles.tableRow]}>
          <Text style={[styles.itemText, { flex: 1 }]}>Submit PHAQ</Text>
          <View style={[styles.checkBoxContainer]}>{this.makeCheckButton()}</View>
          <View style={[styles.checkBoxContainer]} />
          <View style={[styles.checkBoxContainer]} />
        </View>
        <View style={[styles.tableRow]}>
          <Text style={[styles.itemText, { flex: 1 }]}>Complete Hearing Test</Text>
          <View style={[styles.checkBoxContainer]}>{this.makeCheckButton()}</View>
          <View style={[styles.checkBoxContainer]} />
          <View style={[styles.checkBoxContainer]} />
        </View>
        <View style={[styles.tableRow]}>
          <Text style={[styles.itemText, { flex: 1 }]}>Fasting Cholesterol Test</Text>
          <View style={[styles.checkBoxContainer]}>{this.makeCheckButton()}</View>
          <View style={[styles.checkBoxContainer]} />
          <View style={[styles.checkBoxContainer]} />
        </View>
        <View style={[styles.tableRow]}>
          <Text style={[styles.itemText, { flex: 1 }]}>EKG</Text>
          <View style={[styles.checkBoxContainer]}>{this.makeCheckButton()}</View>
          <View style={[styles.checkBoxContainer]} />
          <View style={[styles.checkBoxContainer]} />
        </View>
        <View style={[styles.tableRow]}>
          <Text style={[styles.itemText, { flex: 1 }]}>Sign PHAQ</Text>
          <View style={[styles.checkBoxContainer]}>{this.makeCheckButton()}</View>
          <View style={[styles.checkBoxContainer]}>{this.makeCheckButton()}</View>
          <View style={[styles.checkBoxContainer]}>{this.makeCheckButton()}</View>
        </View>
      </View>
    );
  }

  renderNonFlyPHA() {
    if (!this._due()) return null;
    if (this.props.fly) return null;

    return (
      <View>
        <View style={[THEME.headerAltContrast, { paddingRight: 10, flexDirection: 'row' }]}>
          <Text style={[styles.headerText, { flex: 1, textAlign: 'left' }]}>Step</Text>
          <Text style={[styles.headerText, styles.checkBoxContainer]}>SM</Text>
          <Text style={[styles.headerText, styles.checkBoxContainer]}>BOMC</Text>
          <Text style={[styles.headerText, styles.checkBoxContainer]}>Provider</Text>
        </View>
        <View style={[styles.tableRow]}>
          <Text style={[styles.itemText, { flex: 1 }]}>Submit PHAQ</Text>
          <View style={[styles.checkBoxContainer]}>{this.makeCheckButton()}</View>
          <View style={[styles.checkBoxContainer]} />
          <View style={[styles.checkBoxContainer]} />
        </View>
        <View style={[styles.tableRow]}>
          <Text style={[styles.itemText, { flex: 1 }]}>Complete IMR</Text>
          <View style={[styles.checkBoxContainer]}>{this.makeCheckButton()}</View>
          <View style={[styles.checkBoxContainer]} />
          <View style={[styles.checkBoxContainer]} />
        </View>
        <View style={[styles.tableRow]}>
          <Text style={[styles.itemText, { flex: 1 }]}>Sign PHAQ</Text>
          <View style={[styles.checkBoxContainer]}>{this.makeCheckButton()}</View>
          <View style={[styles.checkBoxContainer]}>{this.makeCheckButton()}</View>
          <View style={[styles.checkBoxContainer]}>{this.makeCheckButton()}</View>
        </View>
      </View>
    );
  }

  renderHeaders() {
    if (!this._due())
      return (
        <View style={styles.completedDateContainer}>
          <Text style={styles.completedDateLabel}>No PHA Currently Due</Text>
        </View>
      );

    const props = this.props;
    const patient = props.editingPatient;
    const approvedDate = patient?.extraData?.pha?.approvedDate;

    const dateStr = DateUtils.formatDateString(approvedDate || new Date());
    return (
      <View style={styles.completedDateContainer}>
        <Text style={styles.completedDateLabel}>PHA Completed:</Text>
        <Text style={styles.headerText}>{dateStr}</Text>
      </View>
    );
  }

  renderProvider() {
    if (!this._due()) return null;
    return (
      <View style={[THEME.inputsContainer]}>
        <FieldLabel label={'PHA/MHA Provider'} required={false} value={'PHA/MHA Provider'} />
        <Text style={styles.displayVal}>{this.props.providerName}</Text>
      </View>
    );
  }

  render() {
    if (!this.props.canView) return <Container style={styles.container} />;
    const checkCount = this.state.checkCount;

    const formReady = this.props.fly ? checkCount === FLY_CHECK_COUNT : checkCount === CHECK_COUNT;

    const approved = this._approved();

    return (
      <Container
        style={styles.container}
        scrollView={true}
        innerContentStyle={!this.props.editingCase ? styles.innerContentStyle : null}
        renderActivityOverlay={this.props.status === REQUESTING}
        successMessage={this.props.status === SUCCESS ? 'Success!' : null}
        errorMessage={this.state.errorMessage}
      >
        {this.renderSelectedCase()}
        {this.renderHeaders()}
        {this.renderDueDate()}
        {this.renderProvider()}
        {this.renderNonFlyPHA()}
        {this.renderFlyPHA()}

        <NextButton
          style={styles.approveBtn}
          onPress={this.approvePHA}
          disabled={!formReady && !approved}
          label={!!approved ? 'REMOVE APPROVAL' : 'APPROVE PHA'}
        />
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  container: __WEB__
    ? {
        ...THEME.container,
        flexBasis: 'initial',
        flexGrow: 0,
      }
    : {
        ...THEME.container,
      },
  innerContentStyle: {
    paddingTop: 60,
  },
  tableRow: {
    ...THEME.headerAltContrast,
    backgroundColor: COLOR.contrast,
    paddingRight: 10,
    flexDirection: 'row',
  },
  itemText: {
    ...FONT.semibold,
    color: COLOR.textLight,
    fontSize: 16,
  },
  checkBoxContainer: {
    width: __WEB__ ? 130 : 80,
    alignItems: 'center',
  },
  checkButton: {
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
  headerText: {
    ...FONT.semibold,
    color: COLOR.text,
    textAlign: 'center',
    fontSize: __WEB__ ? 18 : 16,
  },
  approveBtn: {
    backgroundColor: COLOR.greenColor,
    width: 250,
    alignSelf: 'center',
    borderRadius: 5,
    marginVertical: 25,
  },
  approvedBtn: {
    backgroundColor: COLOR.greenColor,
    width: 250,
    alignSelf: 'center',
    borderRadius: 5,
    marginVertical: 25,
    opacity: 0.7,
  },
  approveBtnText: {},
  completedDateLabel: {
    ...THEME.textRegular,
    width: 150,
    color: COLOR.textLight,
    flex: 1,
  },
  completedDateContainer: {
    ...THEME.headerAltContrast,
    ...THEME.basicRow,
    backgroundColor: 'white',
  },
  displayVal: {
    ...FONT.light,
    color: COLOR.text,
    fontSize: 18,
    marginTop: 5,
  },
  statusDot: {
    width: 20,
    height: 20,
    borderRadius: 20,
  },
});

// '#c7a0f4',
// '#07befa',
// '#6562a4',
// '#f67498',
// '#f08a5d',
// '#ff837b',
// '#f7bf57',
// '#95dce1',

function mapStateToProps(state, ownProps) {
  return {
    status: state.screens.patients.status,
    errorMessage: state.screens.patients.error,
    editingCase: getEditingCase(state),
    editingPatient: getEditingPatient(state),
    userId: state.entities.userProfile.userId,
    providerName: state.entities.userProfile.fullName,
    canEdit: currentEmployerPermissions(PHA).canEdit,
    canView: editingCasePermissions(PHA).canView,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        updatePatientFromCase,
        setEditingPatient,
        resetState,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PHAChecklist);
